import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2
} from '@angular/core';
import {fromPromise} from "rxjs/internal-compatibility";

@Directive({
  selector: '[tooltip]'
})
export class TooltipDirective{
  @Input('tooltip') tooltipTitle: string;
  @Input('tooltip-pos') tooltipPos: string;
  tooltip: HTMLElement;
  offset = 10;
  delay = 200;
  closeTimer: number;
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter') onMouseEnter() {
    if (!this.tooltip && this.tooltipTitle) { this.show(); }
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.tooltip && this.tooltipTitle) { this.hide(); }
  }


  show(isPreventPosition?) {
    clearTimeout(this.closeTimer);
    this.create().subscribe(()=>{
      if (!isPreventPosition){
        this.setPosition();
      }
      this.renderer.addClass(this.tooltip, 'ng-tooltip-show');
    }, (e)=>{console.error('Show tooltip error', e)});
  }

  hide(time?) {
    clearTimeout(this.closeTimer);
    this.renderer.removeClass(this.tooltip, 'ng-tooltip-show');
    this.closeTimer = window.setTimeout(() => {
      if (this.tooltip){
        this.tooltip.remove();
      }
      this.tooltip = null;
    }, time || this.delay);
  }


  private preloadImages(){
    return new Promise((resolve, reject)=>{
      let div = document.createElement('div');
      div.innerHTML = this.tooltipTitle;
      let images = div.querySelectorAll('img');
      if (images.length == 0){
        return resolve();
      }
      let paths = [];
      let loadCounter = 0;
      images.forEach((img)=>{
        let image = new Image();
        image.src = img.src;
        image.onload = function () {
          img.src = image.src;
          loadCounter--;
          if (loadCounter == 0){
            console.log('images loaded');
            return resolve();
          }
        };

        image.onerror = function(){
          loadCounter--;
          if (loadCounter == 0){
            return resolve();
          }
        };
        paths.push(img.src);
        loadCounter++
      });
    })
  }

  create() {
    return fromPromise(new Promise((_resolve, _reject) => {
      let needTooltipToBeCreated = !this.tooltip;
      if (needTooltipToBeCreated) {
        this.tooltip = this.renderer.createElement('span');
      }
      else{
        return _resolve();
      }
      this.renderer.setProperty(
        this.tooltip,
        'innerHTML',
        this.tooltipTitle
      );

      this.preloadImages().then(() => {

        if (needTooltipToBeCreated) {
          if (this.tooltip){
            return;
          }
          this.renderer.appendChild(document.body, this.tooltip);

          this.renderer.addClass(this.tooltip, 'ng-tooltip');
          this.renderer.addClass(this.tooltip, `ng-tooltip-top`);

          (this.tooltipPos) ? this.renderer.addClass(this.tooltip, this.tooltipPos) : this.renderer.addClass(this.tooltip, 'default-pos');

          this.tooltip.addEventListener('mouseenter', () => {
            this.show(true);
          });
          this.tooltip.addEventListener('mouseleave', () => {
            this.hide();
          });
        }

        this.renderer.setStyle(this.tooltip, '-webkit-transition', `opacity ${this.delay}ms`);
        this.renderer.setStyle(this.tooltip, '-moz-transition', `opacity ${this.delay}ms`);
        this.renderer.setStyle(this.tooltip, '-o-transition', `opacity ${this.delay}ms`);
        this.renderer.setStyle(this.tooltip, 'transition', `opacity ${this.delay}ms`);
        _resolve();
      });
    }));
  }

  setPosition() {
    const hostPos = this.el.nativeElement.getBoundingClientRect();
    const tooltipPos = this.tooltip.getBoundingClientRect();

    let top, left;

    if (this.tooltipPos){
     switch (this.tooltipPos) {
       case 'bottom-center':
         top = hostPos.top + hostPos.height + this.offset + 20;
         left =  hostPos.left + (hostPos.width - tooltipPos.width) / 2;
         break;
       case 'top-right':
         top = hostPos.top + hostPos.height/2 - tooltipPos.height;
         left = hostPos.right + 10;
         break;
       case 'center-right':
         top = hostPos.top + hostPos.height/2 - tooltipPos.height/2;
         left = hostPos.right + 10;
         break;
       default:
         top = hostPos.top - tooltipPos.height - this.offset;
         left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
         this.tooltip.style.overflow = 'visible';
         break;
     }
    }
    else {
      top = hostPos.top - tooltipPos.height - this.offset;
      left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
      this.tooltip.style.overflow = 'visible';
    }

    if (left < 0){
      left = 10;
    }
    if (top + this.tooltip.clientHeight > window.innerHeight){
      // top = window.innerHeight - top + this.tooltip.clientHeight;
      let offset = Math.abs(window.innerHeight - (top + this.tooltip.clientHeight));
      top -= offset;
    }
    else if (top < 64){
      top = 74;
    }

    if (this.tooltip.clientHeight+64 > window.innerHeight){
      top = 74;
      this.renderer.setStyle(this.tooltip, 'maxHeight', `${window.innerHeight-64}px`);
      this.renderer.setStyle(this.tooltip, 'overflow-y', `auto`);
    }

    this.renderer.setStyle(this.tooltip, 'top', `${top-10}px`);
    this.renderer.setStyle(this.tooltip, 'left', `${left}px`);
  }

}
